import React, { useRef, useState } from 'react'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import 'react-day-picker/lib/style.css'
import { CalendarDays } from 'lucide-react'

import { jaLocaleUtils } from 'components/dayPickerLocaleUtils'

import styles from './style.module.css'

// WHY: react-day-picker/moment(addon) の MomentLocaleUtils は Vite の依存最適化で ja が en に
// フォールバックし曜日が英語表記になる（dayPickerLocaleUtils.ts 冒頭参照）。自己完結の jaLocaleUtils を使う。
const dayPickerConfig = {
  localeUtils: jaLocaleUtils,
  locale: 'ja',
  firstDayOfWeek: 0,
}

type Props = {
  value: Date
  onChange: (date: Date) => void
}

export const CsvDateField: React.FC<Props> = ({ value, onChange }) => {
  // WHY: DayPickerInput の input は自由入力可能で、パースできない文字列を打つと onDayChange に
  // undefined が渡る。無効値のまま onChange すると呼び出し側の (date: Date) 契約が嘘になり、
  // 表示にも不正文字列が残って value とズレる。無効入力時は onChange を呼ばず、ピッカーを閉じた
  // タイミングで key を変えて DayPickerInput を value から再初期化し、表示を元に戻す。
  const [resetKey, setResetKey] = useState(0)
  const hasInvalidInputRef = useRef(false)

  return (
    <div className={styles.dateField}>
      <DayPickerInput
        key={resetKey}
        value={value}
        dayPickerProps={dayPickerConfig}
        onDayChange={(date?: Date) => {
          if (!date) {
            hasInvalidInputRef.current = true
            return
          }
          hasInvalidInputRef.current = false
          onChange(date)
        }}
        onDayPickerHide={() => {
          if (!hasInvalidInputRef.current) return
          hasInvalidInputRef.current = false
          setResetKey((key) => key + 1)
        }}
        format="YYYY-M-D"
        formatDate={jaLocaleUtils.formatDate}
        parseDate={jaLocaleUtils.parseDate}
        placeholder="YYYY-M-D"
        inputProps={{ className: styles.dateInput }}
      />
      <CalendarDays className={styles.calendarIcon} size={16} aria-hidden={true} />
    </div>
  )
}
